/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesPreviewOverlaps } from "../funcs/killswitchesPreviewOverlaps.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchPreviewOverlapsResult } from "../models/components/killswitchpreviewoverlapsresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  KillswitchesPreviewOverlapsRequest,
  KillswitchesPreviewOverlapsSecurity,
} from "../models/operations/killswitchespreviewoverlaps.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type PreviewKillswitchOverlapsMutationVariables = {
  security: KillswitchesPreviewOverlapsSecurity;
  request: KillswitchesPreviewOverlapsRequest;
  options?: RequestOptions;
};

export type PreviewKillswitchOverlapsMutationData =
  KillswitchPreviewOverlapsResult;

export type PreviewKillswitchOverlapsMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * previewOverlaps killswitches
 */
export function usePreviewKillswitchOverlapsMutation(
  options?: MutationHookOptions<
    PreviewKillswitchOverlapsMutationData,
    PreviewKillswitchOverlapsMutationError,
    PreviewKillswitchOverlapsMutationVariables
  >,
): UseMutationResult<
  PreviewKillswitchOverlapsMutationData,
  PreviewKillswitchOverlapsMutationError,
  PreviewKillswitchOverlapsMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildPreviewKillswitchOverlapsMutation(client, options),
    ...options,
  });
}

export function mutationKeyPreviewKillswitchOverlaps(): MutationKey {
  return ["@gram/client", "killswitches", "previewOverlaps"];
}

export function buildPreviewKillswitchOverlapsMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: PreviewKillswitchOverlapsMutationVariables,
  ) => Promise<PreviewKillswitchOverlapsMutationData>;
} {
  return {
    mutationKey: mutationKeyPreviewKillswitchOverlaps(),
    mutationFn: function previewKillswitchOverlapsMutationFn({
      security,
      request,
      options,
    }): Promise<PreviewKillswitchOverlapsMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(killswitchesPreviewOverlaps(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}
